import { render, staticRenderFns } from "./BookAdd.vue?vue&type=template&id=5102514a&scoped=true&"
import script from "./BookAdd.vue?vue&type=script&lang=js&"
export * from "./BookAdd.vue?vue&type=script&lang=js&"
import style0 from "./BookAdd.vue?vue&type=style&index=0&id=5102514a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102514a",
  null
  
)

export default component.exports